module.exports = __webpack_public_path__ + "static/media/account-selected.7f8419ca.png";